(function(){
    'use strict';

    var $smpHeader = $('.smp-header'),
        $smpLower = $smpHeader.find('.smp-header__lower'),
        $smpSearchContain = $('.smp-header-search'),
        $smpSearchBtn = $('.smp-js-smpsearch-btn'),
        $smpMobileBtn = $('.smp-js-smpmobile-btn'),
        mobileBtnIsVisible = "";

        if($smpSearchContain.length == 1 && $smpSearchBtn.length){

            $smpSearchBtn.click(function(){

                var $cur = $(this),
                btnToggle = squiz.fn.smpToggleBtn($cur);

                mobileBtnIsVisible = $smpMobileBtn.is(':visible');

                if(!btnToggle){

                    if(mobileBtnIsVisible){

                        $smpLower.addClass('open');
                        $smpMobileBtn.addClass('active');

                        setTimeout(function(){
                            $smpSearchContain.find('input[type="text"]').focus();
                        }, squiz.vars.animSpeed);

                    } else {

                        $smpSearchContain.addClass('active');
                        $smpSearchContain.find('input[type="text"]').focus();
                    }

                } else {

                    if(mobileBtnIsVisible){

                        $smpLower.rmoeveClass('open');
                        $smpMobileBtn.removeClass('active');

                    } else {

                        $smpSearchContain.removeClass('active');
                    }
                }

            });

            $(document).mouseup(function(e) {

                if (!$smpSearchContain.is(e.target) && $smpSearchContain.has(e.target).length === 0 && !$smpSearchBtn.is(e.target)) {

                    mobileBtnIsVisible = $smpMobileBtn.is(':visible');

                    if(!mobileBtnIsVisible){
                        $smpSearchBtn.removeClass('active');
                        $smpSearchContain.removeClass('active');
                        $smpSearchContain.find('input[type="text"]').blur();
                    }
                }
            });

            $(window).resize(function(){

                squiz.fn.smpClearNavItemState('.smp-navigation-mega__sub-outer', '.smp-navigation-mega__item-title');

                if($smpHeader.is(':visible')){
                    $smpSearchBtn.removeClass('active');
                    $smpSearchContain.removeClass('active');
                }

            });
        }

}());
